export const ADD_POPUP = 'ADD_POPUP';
export const REMOVE_POPUP = 'REMOVE_POPUP';
export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUP = 'HIDE_POPUP';
